<div class="page-header">
  <div class="grid-container">
    <div class="domain-header" [innerHtml]="domain?.name | domainNameConverter : true"></div>
  </div>
</div>
<div class="grid-container">
<div class="content-header">Review Proposed Changes</div>
<div class="header-helper">
  <div *ngIf="requestMetadata.requestType !== 'REVOKE'">
    <div *ngIf="isStaffUI">
      <p>Please review your changes proposed for this domain,
        and provide a reason for the direct edit.</p>

      <p>If you are satisfied with your changes, select "Proceed" to complete your direct edit
        (scroll to the bottom). If you need to go back and make more changes, select "Back" and continue to
        edit this domain. Select "Cancel" to discard your changes.</p>
    </div>
    <div *ngIf="!isStaffUI">
      <p>If you are satisfied with your changes, select "Proceed" to complete your change request submission
        (scroll to the bottom). If you need to go back and make more changes, select "Back" and continue to
        edit this domain. If you want to cancel your request, select "Cancel" to discard your changes.</p>
    </div>


    <div class="finalize-request" *ngIf="changeRequests && changeRequests.length>1">
      <fa-icon [icon]="'exclamation-triangle'" class="iana-icons align-center"></fa-icon>
      <div style="padding-left: 16px;">
        <div class="grid-x">
          Important: The system has logically split your change into multiple requests for processing. You should see more than one requests to review.
        </div>
      </div>
    </div>
  </div>


</div>

<div class="content content-with-elevation">
  <form [formGroup]="form" (ngSubmit)="confirm()">
    <div class="grid-y">
      <div *ngIf="errorMessages.length > 0" class="form-error is-visible grid-y">
        <div *ngFor="let error of errorMessages">
          {{error}}
        </div>
      </div>
      <div class="grid-y" *ngIf="requestMetadata.requestType !== 'REVOKE'">
        <div class="cell">
          <div class="grid-y">
            <div *ngIf="requestMetadata.requestType === 'DIRECT'" class="grid-x">
              <div class="cell large-2 medium-4 small-12">
                <span class="comment-label">Comment (Required)</span>
              </div>
              <div class="cell large-10 medium-8 small-12">
                <div class="grid-x">
                  <div class="cell large-12 medium-12 small-12">
                    <textarea formControlName="comment" placeholder="Reason for Direct Edit" name="comment" maxlength="256"
                              style="width: 100%"></textarea>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div *ngFor="let changeRequest of changeRequests">
          <summary-of-changes [newDelegation]="requestMetadata.requestType === 'NEW'" [changeRequest]="changeRequest"
                              [showTicketNumbers]="changeRequests.length>1"></summary-of-changes>
        </div>
      </div>
      <div class="grid-x"  *ngIf="requestMetadata.requestType === 'REVOKE'">Domain&nbsp;<b>"{{domain?.name | domainNameConverter}}"</b>&nbsp;is being revoked.</div>


    </div>

    <div class="grid-x" style="margin-top: 1rem;">
      <div class="cell large-12 medium-12 small-12 save-cancel-button-group">
        <button (click)="goBack()" *ngIf="requestMetadata.requestType !== 'REVOKE'" class="iana-button-cancel"  style="margin-right: 8px">Back
        </button>
        <a (click)="cancel()" class="iana-button-cancel">Cancel</a>
        <button class="iana-button" style="float: right;"
                [disabled]="errorMessages.length > 0 || !form.valid">
          Proceed
        </button>
      </div>
    </div>
  </form>
</div>
</div>
